import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import IslamicCalendar1 from '../Calendar/IslamicCalendar1';
import TermsCondition from './TermsCondition';
import PrivacyPolicy from './PrivacyPolicy';

function FooterCalendar() {
   const [showTerms, setShowTerms] = useState(false);
const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
   
    <div className='container-fluid bg_footer p-4'>
        <div className='row'>
            <div className='col-12 col-md-6 col-lg-6 '>
      <div className='row justify-content-center d-flex text-light'>
        <div className='col-lg-4 col-12 col-md-4 col-sm-6 col-xl-4'>
        <h5 className='ft_head'><b>Contact</b></h5>
        <div className='justify-content-start text_footer mb-5'>
            <p><span><i class="bi bi-geo-alt-fill me-2"></i></span>Shopeindia, Warud, Maharashtra, India.</p>
            <p><span><i class="bi bi-telephone-fill me-2"></i></span>7820953826, 7385743121</p>
            <p><span><i class="bi bi-envelope-fill me-2"></i></span>shamun@shopeindia.co.in</p>
            <p><span><i class="bi bi-globe2 me-2"></i></span> <a
      href="https://www.shopeindia.co.in"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text_footer"
    >
      www.shopeindia.co.in
    </a></p>
        </div>
        <h5 className='ft_head'><b>Social Media</b></h5>
           <div className='justify-content-start d-inline-flex gap-4 text_footer '>
              <a
  href="https://youtube.com/@letsfitnfine2940?si=QIKwtOVqODpTJwLy"
  target="_blank"
  rel="noopener noreferrer"
  className='text-decoration-none'
              ><i class="bi bi-youtube p-1 circle_size text-light"></i></a>
              <a
              href=' https://wa.me/917385743121'
               target="_blank"
  rel="noopener noreferrer"
  className='text-decoration-none'
              ><i class="bi bi-whatsapp p-1 circle_size text-light"></i></a>
              <a
              href='https://www.instagram.com/shopeindia_?igsh=MWY5bWdpa2NzbmV5'
               target="_blank"
  rel="noopener noreferrer"
  className='text-decoration-none'
  ><i class="bi bi-instagram p-1 circle_size text-light"></i></a>
              {/* <a><i class="bi bi-youtube p-1 circle_size"></i></a> */}
           </div>
        </div>
        <div className='col-lg-4 col-12 col-md-4 col-sm-6 col-xl-4' >
           <h5 className='ft_head'><b>Quick Links</b></h5>
           <div className='justify-content-start '>
           <p><Link to="/" className=' text-decoration-none text_footer'>Home</Link></p>
           <p><Link to="/About" className=' text-decoration-none text_footer'>About</Link></p>
           <p><Link to="/products" className=' text-decoration-none text_footer'>Product</Link></p>
           <p><Link to="/Contact" className=' text-decoration-none text_footer'>Contact</Link></p>
           <p><Link to="/ShopPage" className=' text-decoration-none text_footer'>Shop</Link></p>
           <p><Link to="/Testimonial" className=' text-decoration-none text_footer'>Testimonial</Link></p>
                      <p><Link to="/Blog" className=' text-decoration-none text_footer'>Blog</Link></p>
           <p><Link to="/coursesection" className=' text-decoration-none text_footer'>Courses</Link></p>
           <p><Link to="/faq" className=' text-decoration-none text_footer'>FAQ</Link></p>
        </div>
        </div>
        {/* <div className='col-lg-2 col-12 col-md-2 col-sm-6 col-xl-2'>
           <h5 className='ft_head'><b>Specialties</b></h5>
           <div className='justify-content-start text_footer'>
           <p>Anesthesiology</p>
           <p>Psychiatry</p>
           <p>General surgery</p>
           <p>Family medicine</p>
           <p>Pediatrics</p>
        </div>
        </div> */}
        <div className='col-lg-4 col-12 col-md-4 col-sm-6 col-xl-4'>
          <h5 className='ft_head'><b>Services</b></h5>
          <div className='justify-content-start text_footer'>
          <p>Dermatology Equipments</p>
          <p>Massage & Wellness Products</p>
          <p>Hijama / Acupressure Tools</p>
          <p>Aesthetic & Beauty Devices</p>
          <p>Healthcare Tools & Devices</p>
        </div>
        </div>
        {/* <div className='col-lg-3 col-12 col-md-3 col-sm-6 col-xl-3'>
           <h5 className='ft_head'><b>Social Media</b></h5>
           <div className='justify-content-start d-inline-flex gap-4 text_footer'>
              <a><i class="bi bi-facebook p-1 circle_size "></i></a>
              <a><i class="bi bi-linkedin p-1 circle_size"></i></a>
              <a><i class="bi bi-instagram p-1 circle_size"></i></a>
           </div>
        </div> */}
        
      </div>
      </div>
      <div className='col-12 col-md-6 col-lg-6 '>
        {/* <IslamicCalendar/> */}
        <IslamicCalendar1/>
      </div>
      </div>
      <hr className='text_footer '></hr>
      <div className='justify-content-between text_footer d-flex'>
          <div><p>© 2025 HEALTHY. All rights reserved. | Designed by Shopeindia</p></div>
          <div className='d-inline-flex'>
         <p className='me-4' style={{cursor:"pointer"}} onClick={() => setShowTerms(true)}>Terms and Conditions</p>
     <p style={{cursor:"pointer"}} onClick={() => setShowPrivacy(true)}>Privacy Policy</p></div>
      </div>
    </div>
   
{showTerms && <TermsCondition onClose={() => setShowTerms(false)} />}
{showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}
   
  
    </>
  )
}

export default FooterCalendar;
